import { matchPath } from 'react-router';
import RoutesItems from '../../Routes/RoutesItems';

const getMatchDetails = (pathname, item) => {
  if (!item?.route) {
    return null;
  }

  const match = matchPath(
    {
      path: item.route,
      end: true,
    },
    pathname
  );

  if (!match) {
    return null;
  }

  const routePath = item.route.replace(/\/+$/, '') || '/';
  const segments = routePath.split('/').filter(Boolean);
  const staticSegments = segments.filter((segment) => !segment.startsWith(':')).length;

  return {
    item,
    isExact: routePath === pathname,
    segmentCount: segments.length,
    staticSegments,
  };
};

export const getMatchedRoute = (pathname, routes = RoutesItems) => {
  const normalizedPathname = pathname.replace(/\/+$/, '') || '/';
  const candidates = routes
    .map((item) => getMatchDetails(normalizedPathname, item))
    .filter(Boolean)
    .sort((left, right) => {
      if (left.isExact !== right.isExact) {
        return left.isExact ? -1 : 1;
      }

      if (left.segmentCount !== right.segmentCount) {
        return right.segmentCount - left.segmentCount;
      }

      if (left.staticSegments !== right.staticSegments) {
        return right.staticSegments - left.staticSegments;
      }

      return 0;
    });

  return candidates[0]?.item || null;
};

export const getRouteLineage = (pathname, routes = RoutesItems) => {
  const matchedRoute = getMatchedRoute(pathname, routes);

  if (!matchedRoute) {
    return [];
  }

  const routeMap = new Map(
    routes
      .filter((item) => item?.id !== undefined && item?.id !== null)
      .map((item) => [item.id, item])
  );

  const lineage = [matchedRoute];
  let currentRoute = matchedRoute;

  while (currentRoute?.parentid !== undefined && currentRoute?.parentid !== null) {
    const parentRoute = routeMap.get(currentRoute.parentid);

    if (!parentRoute) {
      break;
    }

    lineage.unshift(parentRoute);
    currentRoute = parentRoute;
  }

  return lineage;
};

export const getRouteMeta = (pathname, routes = RoutesItems) => {
  const matchedRoute = getMatchedRoute(pathname, routes);
  const lineage = getRouteLineage(pathname, routes);
  const title =
    matchedRoute?.page_title ||
    matchedRoute?.text ||
    lineage[lineage.length - 1]?.page_title ||
    lineage[lineage.length - 1]?.text ||
    'Dashboard';
  const eyebrow =
    matchedRoute?.page_eyebrow ||
    lineage[0]?.page_title ||
    lineage[0]?.text ||
    'Operations Workspace';
  const breadcrumbLineage = lineage.filter((item, index) => {
    const label = (item?.text || item?.page_title || '').trim().toLowerCase();

    return !(index === 0 && label === 'dashboard');
  });
  const trailBreadcrumbs = breadcrumbLineage.map((item, index) => ({
    label: item.text || item.page_title || 'Workspace',
    to:
      index < breadcrumbLineage.length - 1 && item.route && !item.route.includes(':')
        ? item.route
        : undefined,
  }));
  const iconSourceRoute = [...lineage]
    .reverse()
    .find((item) => item?.iconReact || item?.iconsvg || item?.icon);
  const breadcrumbs =
    matchedRoute
      ? [
          {
            label: iconSourceRoute?.text || matchedRoute?.text || title,
            isPageIcon: true,
            iconReact: iconSourceRoute?.iconReact,
            iconsvg: iconSourceRoute?.iconsvg,
            icon: iconSourceRoute?.icon,
            icon_type: iconSourceRoute?.icon_type,
          },
          ...trailBreadcrumbs,
        ]
      : [];

  return {
    matchedRoute,
    lineage,
    title,
    eyebrow,
    description: matchedRoute?.page_description || '',
    breadcrumbs,
  };
};
